import { gsap } from "gsap";

import './fade-effect.scss';

export class FadeEffect {

	constructor( el: HTMLElement ) {
		const opacityValue = ( el.dataset.opacity ? el.dataset.opacity : 1 );
		gsap.to(el, { opacity: opacityValue });
	}

}
